<template>
    <div class="vue timparty-rewards rewards" v-if="access_token && rewards">
        <LoaderOverlay v-if="loading"/>

        <div class="vantaggi mx-2">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                  <h1>{{ __('I tuoi vantaggi, sempre con te') }}</h1>
                  <user-cluster></user-cluster>
<!--                  <span class="spaced-text blue">{{ current_tier_claim }}</span>-->
                  <p class="mx-3 mx-md-0">{{ __('Hai sempre accesso a un mondo gratuito di vantaggi e prodotti selezionati in esclusiva per te.') }}
                      <br class="d-none d-lg-block">
                      {{ __('Vivere le tue passioni è davvero facile e senza limiti!') }}
                  </p>
                </div>
            </div>
            <div class="rewards-slider" v-if="rewards">
                <div class="slide-content px-2" v-for="reward in rewards" v-bind:key="reward.rewardId">
                    <rewards-card :reward="reward" v-if="reward.rewardId"></rewards-card>
                </div>
            </div>

            <div class="text-center py-4 mt-4">
                <a v-if="catalogUrl" @click='aaEvent("click", { form: { click: "Scopri vantaggi" } })' :href="catalogUrl" class="btn btn-lg btn-outline-primary text-uppercase cta-generic">{{ __('Scopri tutti i vantaggi disponibili') }}</a>
            </div>

        </div>

    </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import RewardsCard from './RewardsCard.vue'
import UserCluster from './UserCluster.vue'
import $ from 'jquery';
import 'slick-carousel';

export default {
    name: 'RewardsSliderCurrentTier',
    mixins: [TimPartyMixin],
    components: {LoaderOverlay, RewardsCard, UserCluster},
    props: {

        apiUrl: String,
        catalogUrl: String,
        homepage: Boolean,
    },
    data: function () {
        return {
            rewards: null,
        };
    },
    mounted: function () {
        this.setApiUrl(this.apiUrl);

        if(this.access_token)
            this.getRewards();

    },
    methods: {
        activateSlider: function () {
            this.$nextTick( function() {
                $('.rewards-slider').slick({
                    dots: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 4.1,
                    slidesToScroll: 4,
                    autoplay: false,
                    responsive: [

                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2.1,
                                slidesToScroll: 1,
                                dots: false,
                    //
                            }
                        },
                        {
                            breakpoint: 520,
                            settings: {
                                slidesToShow: 1.1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: false,
                            }
                        }
                    ]
                });
            });
        },

        getRewards: function(){

          var self = this;

          var payload = {
            action: 'getRewards',
            access_token: this.access_token,
            homepage: this.homepage,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;

            if(response.rewards != undefined){
                self.rewards = response.rewards;
                self.activateSlider();
            }

          } );

        },
        /*
        gotoCatalogClick: function(){

          this.aaEvent('click', {
                            form: {
                                click: 'Scopri vantaggi',
                                }
                            });

        },
        */

    },
    computed: {
      current_tier_claim: function(){
          return  this.__('Per te che sei cliente '+ this.user.cluster_name); //TODO: make it dynamic
      },
    },
    watch: {
        access_token: function( new_val, old_val){
            this.getRewards();
        }
    }
}
</script>


